import { Component, OnInit } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { ApplicationService } from '../../../services/application.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { TemplateService } from '../../../services/template.service';
import { practiceSessionTemplateResponse } from '../../../models/practiceSessionTemplateResponse';

@Component({
  selector: 'app-template-list',
  standalone: true,
  imports: [NgIf, NgFor],
  templateUrl: './template-list.component.html',
  styleUrl: './template-list.component.css'
})
export class TemplateListComponent implements OnInit{
  constructor(private applicationService:ApplicationService, private authenticationService:AuthenticationService, private templateService:TemplateService) {

  }

  templates:Array<practiceSessionTemplateResponse> = [];

  ngOnInit(): void {
    this.getTemplates();
  }

  async getTemplates() {
    let username = this.authenticationService.loggedInUser?.username;
    if(!username) return;

    this.applicationService.showGlobalSpinner();
    let result = await this.templateService.searchTemplates(username);
    this.templates = result;
    this.applicationService.hideGlobalSpinner();
  }
}
